/* MGH-MASCOTE (30/09/2026): a Yuki espreita por tras de elementos do site; ao passar o rato (computador) ou quando o
   sitio dela entra no ecra (telemovel/tablet) desfaz-se em fumo ninja, o balao "Hi Hi Hi" sai da nuvem (direcao das 14h)
   e ela salta para outro sitio (visivel no computador, fora do ecra no telemovel).
   Para reverter: apagar assets/mgh-mascote.js, assets/mgh-mascote.css e tudo o que estiver marcado MGH-MASCOTE. */
(function () {
  'use strict';
  if (window.__mghMascote) return;
  window.__mghMascote = true;

  var cfg = Object.assign({
    img: '',
    css: '',
    chance: 1,
    maxEscapes: 5,
    mobile: true,
    startDelay: 1200,
    outChance: 0.6,
    text: 'Hi Hi Hi'
  }, window.MGH_MASCOTE || {});
  if (!cfg.img) return;
  if (Math.random() > cfg.chance) return;

  var coarse = window.matchMedia('(hover: none), (pointer: coarse)').matches;
  if (coarse && !cfg.mobile) return;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  /* Modo scroll (telemovel/tablet): a Yuki espera num sitio fora do ecra; quando esse sitio fica visivel ela espreita,
     desfaz-se em fumo com o balao e salta para outro sitio fora do ecra. Modo hover (computador): foge ao passar o rato.
     Para testar o modo scroll no computador: acrescentar &yk=scroll ao link de pre-visualizacao. */
  var scrollMode = /[?&]yk=scroll/.test(location.search) || cfg.mode === 'scroll' ||
    (cfg.mode !== 'hover' && !/[?&]yk=hover/.test(location.search) && coarse);
  var SEEN_DELAY = 900;
  var RATIO = 480 / 361;
  var PEEK = 0.44;
  var TRIES = 4;

  /* Sitios onde a Yuki pode espreitar.
     top:   por cima da borda de cima do elemento, sempre inteira em cima dele (cartoes, imagens, rodape).
     dots:  por tras do pontilhado desenhado por cima dos titulos, em qualquer ponto da linha;
            sem pontilhado, fica em cima da primeira linha do texto do titulo.
     right: de lado, a sair de tras do logo, sem passar a altura do logo.
     Nos cartoes usa-se o elemento que sobe com a animacao do tema (.card--card ou .card__inner). */
  var CARD = ' .card-wrapper .card--card, ';
  var INNER = ' .card-wrapper .card--standard .card__inner';
  var SPOTS = [
    { sel: '.header__heading-link', mode: 'right' },
    { sel: '.rich-text__heading', mode: 'dots' },
    { sel: '#MainContent .image-with-text__heading', mode: 'dots' },
    { sel: '#MainContent .image-with-text__media', mode: 'top' },
    { sel: '.product-grid' + CARD + '.product-grid' + INNER, mode: 'top' },
    { sel: '.collection-list' + CARD + '.collection-list' + INNER, mode: 'top' },
    { sel: '.multicolumn-card', mode: 'top' },
    { sel: '.blog__post' + CARD + '.blog__post' + INNER, mode: 'top' },
    { sel: '.footer', mode: 'top', edge: 0.05 }
  ];

  var cur = null;
  var busy = false;
  var done = false;
  var pending = false;
  var pendingPuff = false;
  var escapes = 0;
  var lastEl = null;
  var lastSel = null;
  var FIRST_SCROLL = 40;

  function shuffle(a) {
    for (var i = a.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var t = a[i]; a[i] = a[j]; a[j] = t;
    }
    return a;
  }

  function R(left, top, width, height) {
    return { left: left, top: top, width: width, height: height, right: left + width, bottom: top + height };
  }

  function clips(el) {
    var cs = getComputedStyle(el);
    return cs.overflowX !== 'visible' || cs.overflowY !== 'visible';
  }

  /* Um bloco so serve de ponto de aparecimento se estiver mesmo visivel: sem display none, visibility hidden,
     opacidade quase zero, atributo hidden/inert/aria-hidden, e sem estar fora de um pai que o corta
     (ex.: slide de carrossel que nao esta a ser mostrado). */
  function isShown(el) {
    if (!el || !el.isConnected) return false;
    if (el.closest('[hidden],[inert],[aria-hidden="true"]')) return false;
    var r = el.getBoundingClientRect();
    if (r.width < 8 || r.height < 8) return false;
    for (var a = el; a && a !== document.body; a = a.parentElement) {
      var cs = getComputedStyle(a);
      if (cs.display === 'none' || cs.visibility === 'hidden' || cs.contentVisibility === 'hidden') return false;
      if (parseFloat(cs.opacity) < 0.1) return false;
      if (a !== el && (cs.overflowX !== 'visible' || cs.overflowY !== 'visible')) {
        var b = a.getBoundingClientRect();
        if (r.right <= b.left + 4 || r.left >= b.right - 4 || r.bottom <= b.top + 4 || r.top >= b.bottom - 4) return false;
      }
    }
    return true;
  }

  function textRect(el) {
    var rg = document.createRange();
    rg.selectNodeContents(el);
    var rs = rg.getClientRects();
    for (var i = 0; i < rs.length; i++) {
      if (rs[i].width > 2 && rs[i].height > 2) return rs[i];
    }
    return null;
  }

  function dotsInfo(el) {
    var cs = getComputedStyle(el);
    if (!/radial-gradient/.test(cs.backgroundImage)) return null;
    var size = cs.backgroundSize.split(' ');
    var tile = parseFloat(size[0]) || 20;
    var band = parseFloat(size[1]) || 10;
    var bg = (cs.getPropertyValue('--color-background') || '').trim();
    return { image: cs.backgroundImage, size: cs.backgroundSize, tile: tile, band: band, bg: bg ? 'rgb(' + bg + ')' : '' };
  }

  /* f (0 a 1) escolhe a posicao ao longo do objeto: a Yuki fica sempre inteira dentro dos limites dele. */
  function geometry(el, s, f) {
    var small = window.innerWidth < 750;
    var mode = s.mode;
    var dots = mode === 'dots' ? dotsInfo(el) : null;
    var textLine = mode === 'dots' && !dots;
    if (mode === 'dots') mode = 'top';
    var box = el.getBoundingClientRect();
    var w, h, v, rect, imgLeft, hidden, shown, overlay = null;
    if (mode === 'top') {
      w = small ? 78 : 104;
      h = w * RATIO;
      v = Math.round(h * PEEK);
      var minL, maxL, base;
      if (dots) {
        minL = box.left + dots.tile;
        maxL = box.right - dots.tile - w;
        base = box.top + dots.band;
        v += dots.band;
      } else if (textLine) {
        var a = textRect(el);
        if (!a) return null;
        minL = a.left;
        maxL = a.right - w;
        base = a.top;
      } else {
        var m = Math.max(12, parseFloat(getComputedStyle(el).borderTopRightRadius) || 0) + 4;
        if (s.edge) m = Math.max(m, box.width * s.edge);
        minL = box.left + m;
        maxL = box.right - m - w;
        base = box.top;
      }
      if (maxL < minL) return null;
      var left = Math.round(minL + f * (maxL - minL));
      rect = R(left, base - v, w, v);
      imgLeft = 0;
      hidden = 'translate(0,' + (v + 4) + 'px)';
      shown = 'translate(0,0)';
      if (dots) {
        var x0 = box.left + (box.width - dots.tile) / 2 - left;
        x0 = ((x0 % dots.tile) + dots.tile) % dots.tile;
        overlay = {
          height: dots.band + 'px',
          backgroundImage: dots.image + (dots.bg ? ', linear-gradient(' + dots.bg + ', ' + dots.bg + ')' : ''),
          backgroundSize: dots.size + (dots.bg ? ', 100% 100%' : ''),
          backgroundRepeat: 'repeat-x' + (dots.bg ? ', no-repeat' : ''),
          backgroundPosition: x0 + 'px 0' + (dots.bg ? ', 0 0' : '')
        };
      }
    } else {
      h = Math.min(small ? 96 : 124, box.height);
      if (h < 56) return null;
      w = h / RATIO;
      var vw = Math.round(w * 0.5);
      var top = Math.round(box.top + f * (box.height - h));
      rect = R(mode === 'right' ? box.right : box.left - vw, top, vw, h);
      imgLeft = mode === 'right' ? vw - w : 0;
      hidden = 'translate(' + (mode === 'right' ? -(vw + 4) : vw + 4) + 'px,0)';
      shown = 'translate(0,0) rotate(' + (mode === 'right' ? 6 : -6) + 'deg)';
    }
    var cont = clips(el) ? el.parentElement : el;
    if (!cont) return null;
    return { el: el, mode: mode, rect: rect, w: w, imgLeft: imgLeft, hidden: hidden, shown: shown, cont: cont, overlay: overlay };
  }

  /* Tudo o que nao pode ser tapado: texto, imagens, icones, botoes, campos, precos e badges. */
  function obstacles() {
    var out = [];
    var walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, {
      acceptNode: function (n) {
        if (!n.nodeValue.trim()) return NodeFilter.FILTER_REJECT;
        var p = n.parentElement;
        if (!p || p.closest('script,style,noscript,template,.yk-layer')) return NodeFilter.FILTER_REJECT;
        return NodeFilter.FILTER_ACCEPT;
      }
    });
    var rg = document.createRange();
    var n;
    while ((n = walker.nextNode())) {
      rg.selectNodeContents(n);
      var rs = rg.getClientRects();
      for (var i = 0; i < rs.length; i++) {
        if (rs[i].width > 2 && rs[i].height > 2) out.push(rs[i]);
      }
    }
    var els = document.querySelectorAll('img,svg,video,iframe,button,input,select,textarea,.button,.badge,.price');
    /* Camadas invisiveis do tamanho do ecra (extensoes, widgets) nao contam como conteudo. */
    var huge = window.innerWidth * window.innerHeight * 0.5;
    for (var k = 0; k < els.length; k++) {
      if (els[k].closest('.yk-layer')) continue;
      var r = els[k].getBoundingClientRect();
      if (r.width > 2 && r.height > 2 && r.width * r.height < huge) out.push(r);
    }
    return out;
  }

  function hits(r, obs) {
    var t = R(r.left - 3, r.top - 3, r.width + 6, r.height + 3);
    for (var i = 0; i < obs.length; i++) {
      var o = obs[i];
      if (o.right > t.left && o.left < t.right && o.bottom > t.top && o.top < t.bottom) return true;
    }
    return false;
  }

  /* Se um pai com overflow escondido cortava a Yuki, ela passa a ficar presa ao pai de fora desse elemento.
     Nunca sai de zonas que deslizam (overflow auto/scroll) nem de cartoes (perderia a animacao do hover). */
  function fits(g) {
    var r = g.rect;
    if (r.left < 4 || r.right > document.documentElement.clientWidth - 4) return false;
    for (var a = g.cont; a && a !== document.body; a = a.parentElement) {
      if (!clips(a)) continue;
      var b = a.getBoundingClientRect();
      if (r.left < b.left - 1 || r.right > b.right + 1 || r.top < b.top - 1 || r.bottom > b.bottom + 1) {
        var cs = getComputedStyle(a);
        if (/auto|scroll/.test(cs.overflowX + cs.overflowY)) return false;
        if (a.matches('.card, .card__inner, .card-wrapper')) return false;
        if (!a.parentElement) return false;
        g.cont = a.parentElement;
      }
    }
    return true;
  }

  function headerBottom() {
    var h = document.querySelector('.section-header');
    if (!h) return 0;
    var b = h.getBoundingClientRect();
    return b.bottom > 0 ? b.bottom : 0;
  }

  function inView(r) {
    return r.top >= headerBottom() && r.bottom <= window.innerHeight;
  }

  /* Totalmente fora do ecra (acima, por baixo do cabecalho fixo, ou abaixo), com margem de 20 px. */
  function offScreen(r) {
    return r.bottom < headerBottom() - 20 || r.top > window.innerHeight + 20;
  }

  function groups() {
    var list = SPOTS.map(function (s) {
      return { s: s, els: Array.prototype.slice.call(document.querySelectorAll(s.sel)) };
    });
    var tagged = document.querySelectorAll('[data-mascote]');
    for (var i = 0; i < tagged.length; i++) {
      list.push({ s: { sel: '[data-mascote]', mode: tagged[i].getAttribute('data-mascote') || 'top' }, els: [tagged[i]] });
    }
    return shuffle(list);
  }

  /* where = 'in' (so sitios visiveis no ecra) ou 'out' (so sitios fora do ecra, de preferencia mais abaixo).
     Prioridade: outro tipo de sitio > mesmo tipo do anterior (e, fora do ecra, abaixo > acima). */
  function pick(avoidEl, avoidSel, where) {
    var out = where === 'out';
    var obs = null;
    var best = null;
    var bestScore = 99;
    var gs = groups();
    for (var g = 0; g < gs.length; g++) {
      var s = gs[g].s;
      var els = shuffle(gs[g].els);
      for (var e = 0; e < els.length; e++) {
        var el = els[e];
        if (el === avoidEl || !isShown(el)) continue;
        for (var t = 0; t < TRIES; t++) {
          var geo = geometry(el, s, Math.random());
          if (!geo) break;
          if (out ? !offScreen(geo.rect) : !inView(geo.rect)) continue;
          obs = obs || obstacles();
          if (hits(geo.rect, obs) || !fits(geo)) continue;
          geo.sel = s.sel;
          geo.out = out;
          var score = (avoidSel && geo.sel === avoidSel ? 1 : 0) + (out && geo.rect.top < 0 ? 2 : 0);
          if (score === 0) return geo;
          if (score < bestScore) { best = geo; bestScore = score; }
          break;
        }
      }
    }
    return best;
  }

  function mount(g) {
    var cont = g.cont;
    var restore = false;
    if (getComputedStyle(cont).position === 'static') {
      cont.style.position = 'relative';
      restore = true;
    }
    var cr = cont.getBoundingClientRect();
    var wrap = document.createElement('div');
    wrap.className = 'yk-layer yk-peek yk-' + g.mode;
    wrap.setAttribute('aria-hidden', 'true');
    wrap.style.left = (g.rect.left - cr.left - cont.clientLeft) + 'px';
    wrap.style.top = (g.rect.top - cr.top - cont.clientTop) + 'px';
    wrap.style.width = g.rect.width + 'px';
    wrap.style.height = g.rect.height + 'px';
    var img = new Image();
    img.alt = 'Yuki, a mascote da Multiverse Geek House';
    img.draggable = false;
    img.className = 'yk-img';
    img.style.width = g.w + 'px';
    img.style.left = g.imgLeft + 'px';
    img.src = cfg.img;
    wrap.appendChild(img);
    if (g.overlay) {
      var ov = document.createElement('div');
      ov.className = 'yk-line';
      for (var k in g.overlay) ov.style[k] = g.overlay[k];
      wrap.appendChild(ov);
    }
    cont.appendChild(wrap);

    img.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') flee(); });
    img.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse') { e.preventDefault(); if (m.revealed || !scrollMode) flee(); }
    });
    img.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); flee(); });

    var m = { g: g, wrap: wrap, img: img, cont: cont, restore: restore, revealed: false, seenAt: 0 };
    return m;
  }

  function unmount(m) {
    if (!m) return;
    m.wrap.remove();
    if (m.restore) m.cont.style.position = '';
  }

  function vanish(m) {
    m.wrap.classList.add('is-gone');
    setTimeout(function () { unmount(m); }, 160);
  }

  function appear(g, puff) {
    var m = mount(g);
    cur = m;
    lastEl = g.el;
    lastSel = g.sel;
    var img = m.img;
    img.style.transform = reduce ? g.shown : g.hidden;
    img.style.opacity = '0';
    syncHidden();
    /* Num sitio fora do ecra fica escondida atras do objeto ate esse sitio ficar visivel (ver watchSeen). */
    if (g.out) return;
    m.revealed = true;
    var go = function () {
      void img.offsetWidth;
      requestAnimationFrame(function () {
        img.style.transform = g.shown;
        img.style.opacity = '1';
      });
      if (puff) {
        var r = m.wrap.getBoundingClientRect();
        smoke(r.left + r.width / 2 + window.scrollX, r.top + r.height / 2 + window.scrollY, 0.55);
      }
    };
    if (img.complete) go(); else img.addEventListener('load', go, { once: true });
  }

  /* Quando o sitio (fora do ecra) dela fica totalmente visivel, espreita.
     So no modo scroll: SEEN_DELAY depois desfaz-se em fumo e salta. */
  function watchSeen() {
    if (!cur || busy || done) return;
    var m = cur;
    if (m.first && m.revealed) return;
    if (m.revealed && !scrollMode) return;
    if (m.wrap.style.visibility === 'hidden') { m.seenAt = 0; return; }
    var r = m.wrap.getBoundingClientRect();
    var full = r.width > 0 && r.top >= headerBottom() && r.bottom <= window.innerHeight;
    if (!full) {
      if (!m.revealed) m.seenAt = 0;
      return;
    }
    if (!m.seenAt) {
      m.seenAt = Date.now();
      m.revealed = true;
      m.revealY = window.scrollY;
      requestAnimationFrame(function () {
        m.img.style.transform = m.g.shown;
        m.img.style.opacity = '1';
      });
      return;
    }
    if (scrollMode && !m.first && Date.now() - m.seenAt >= SEEN_DELAY) flee();
  }

  /* Onde procurar: telemovel sempre fora do ecra; computador ao abrir e em recolocacoes, primeiro no ecra;
     computador depois de uma fuga, fora do ecra com probabilidade outChance (60%) e no ecra no resto (40%).
     Se nao houver sitio do lado escolhido, tenta o outro; se nao houver nenhum, fica a espera. */
  function relocate(puff, jump) {
    if (done) return;
    var first = scrollMode ? 'out' : (jump && Math.random() < cfg.outChance ? 'out' : 'in');
    var g = pick(lastEl, lastSel, first);
    if (!g && !scrollMode) g = pick(lastEl, lastSel, first === 'out' ? 'in' : 'out');
    if (g) {
      pending = false;
      appear(g, puff && !g.out);
    } else {
      pending = true;
      pendingPuff = puff;
    }
  }

  function smoke(x, y, scale) {
    if (reduce) return;
    var layer = document.createElement('div');
    layer.className = 'yk-layer yk-smoke';
    layer.setAttribute('aria-hidden', 'true');
    layer.style.left = x + 'px';
    layer.style.top = y + 'px';
    var core = document.createElement('span');
    core.className = 'yk-core';
    core.style.width = core.style.height = Math.round(52 * scale) + 'px';
    layer.appendChild(core);
    var n = 10;
    for (var i = 0; i < n; i++) {
      var p = document.createElement('span');
      var ang = (i / n) * Math.PI * 2 + Math.random() * 0.5;
      var dist = (24 + Math.random() * 22) * scale;
      var size = Math.round((20 + Math.random() * 22) * scale);
      p.style.width = p.style.height = size + 'px';
      p.style.setProperty('--dx', Math.round(Math.cos(ang) * dist) + 'px');
      p.style.setProperty('--dy', Math.round(Math.sin(ang) * dist - 6) + 'px');
      p.style.animationDelay = Math.round(Math.random() * 60) + 'ms';
      layer.appendChild(p);
    }
    document.body.appendChild(layer);
    setTimeout(function () { layer.remove(); }, 750);
  }

  /* Balao a sair da nuvem na direcao das 14h de um relogio (60 graus a partir das 12h).
     Se nao couber a direita, sai na direcao das 10h. (cx, cy) = centro da nuvem, em coordenadas do ecra. */
  function bubble(cx, cy, rad) {
    var TAIL = 12;
    var b = document.createElement('div');
    b.className = 'yk-layer yk-bubble';
    b.setAttribute('aria-hidden', 'true');
    b.textContent = cfg.text;
    document.body.appendChild(b);
    var bw = b.offsetWidth;
    var bh = b.offsetHeight;
    var vw = document.documentElement.clientWidth;
    var d = rad + 8;
    var dx = Math.round(Math.sin(Math.PI / 3) * d);
    var dy = Math.round(Math.cos(Math.PI / 3) * d);
    var right = cx + dx - TAIL + bw <= vw - 8;
    var px = right ? cx + dx : cx - dx;
    var py = cy - dy;
    var left = right ? px - TAIL : px - bw + TAIL;
    var top = Math.max(8, py - TAIL - bh);
    if (!right) b.classList.add('yk-bubble--l');
    b.style.left = (left + window.scrollX) + 'px';
    b.style.top = (top + window.scrollY) + 'px';
    b.style.setProperty('--fx', Math.round(cx - px) + 'px');
    b.style.setProperty('--fy', Math.round(cy - py) + 'px');
    requestAnimationFrame(function () { requestAnimationFrame(function () { b.classList.add('is-on'); }); });
    return b;
  }

  function flee() {
    if (busy || !cur) return;
    busy = true;
    escapes++;
    var m = cur;
    cur = null;
    var ir = m.img.getBoundingClientRect();
    var wr = m.wrap.getBoundingClientRect();
    var l = Math.max(ir.left, wr.left);
    var t = Math.max(ir.top, wr.top);
    var r = Math.min(ir.right, wr.right);
    var btm = Math.min(ir.bottom, wr.bottom);
    var cx = (l + r) / 2;
    var cy = (t + btm) / 2;
    smoke(cx + window.scrollX, cy + window.scrollY, 1.1);
    vanish(m);
    var b = bubble(cx, cy, Math.max(r - l, btm - t) / 2);
    setTimeout(function () {
      b.classList.remove('is-on');
      setTimeout(function () { b.remove(); }, 260);
    }, 1000);
    if (cfg.maxEscapes && escapes >= cfg.maxEscapes) done = true;
    setTimeout(function () {
      busy = false;
      relocate(!scrollMode, true);
    }, 1100);
  }

  /* Esconde a Yuki quando abre o menu, a pesquisa ou a gaveta do carrinho. */
  function syncHidden() {
    if (!cur) return;
    var open = /overflow-hidden/.test(document.body.className) ||
      document.querySelector('cart-drawer.active, header details[open], .menu-drawer-container[open]');
    cur.wrap.style.visibility = open ? 'hidden' : '';
  }

  /* Vigia: se o bloco onde ela esta for escondido, ela sai dali; se estiver a espera, tenta aparecer. */
  function tick() {
    if (done || busy) return;
    if (cur) {
      if (!isShown(cur.g.el)) {
        var m = cur;
        cur = null;
        vanish(m);
        relocate(false);
      }
    } else if (pending) {
      relocate(pendingPuff);
    }
  }

  function watch() {
    var mo = new MutationObserver(syncHidden);
    mo.observe(document.body, { attributes: true, attributeFilter: ['class'] });
    var header = document.querySelector('.section-header');
    if (header) mo.observe(header, { attributes: true, attributeFilter: ['open', 'class'], subtree: true });
    setInterval(tick, 700);
    setInterval(watchSeen, 150);
    var st = null;
    window.addEventListener('scroll', function () {
      /* Primeiro sitio (hero): se a pessoa fizer scroll sem lhe tocar, ela salta. */
      if (cur && cur.first && cur.revealed && !busy && Math.abs(window.scrollY - cur.revealY) > FIRST_SCROLL) flee();
      if (!pending || st) return;
      st = setTimeout(function () { st = null; tick(); }, 250);
    }, { passive: true });
    var lastW = window.innerWidth;
    var rt = null;
    window.addEventListener('resize', function () {
      if (window.innerWidth === lastW) return;
      lastW = window.innerWidth;
      clearTimeout(rt);
      rt = setTimeout(function () {
        if (busy || done) return;
        if (cur) {
          unmount(cur);
          cur = null;
        }
        lastEl = null;
        relocate(false);
      }, 300);
    });
  }

  /* Primeiro sitio, numa posicao aleatoria da linha de pontilhado:
     computador: titulo do hero (primeiro .image-with-text__heading);
     telemovel: titulo "Mais Vendidos em TCG's e Colecionaveis" (primeiro .rich-text__heading da homepage).
     Se o titulo estiver abaixo da parte visivel, fica escondida ate ele aparecer. Se a pagina abrir ja depois
     desse titulo (ex.: voltar atras), comeca pelas regras normais. */
  function firstSpot() {
    var s = scrollMode ?
      { sel: '#MainContent .rich-text__heading', mode: 'dots' } :
      { sel: '#MainContent .image-with-text__heading', mode: 'dots' };
    var el = document.querySelector(s.sel);
    if (!el || !isShown(el) || !dotsInfo(el)) return null;
    var obs = obstacles();
    for (var t = 0; t < 8; t++) {
      var geo = geometry(el, s, Math.random());
      if (!geo) return null;
      if (geo.rect.top < headerBottom() || hits(geo.rect, obs) || !fits(geo)) continue;
      geo.sel = s.sel;
      geo.out = !inView(geo.rect);
      return geo;
    }
    return null;
  }

  /* No primeiro sitio, se a pessoa fizer scroll sem lhe tocar, ela salta (ver o listener de scroll em watch).
     O scroll so conta a partir do momento em que ela ficou visivel. */
  function start() {
    var pre = new Image();
    pre.src = cfg.img;
    var g = firstSpot();
    if (g) {
      pending = false;
      appear(g, false);
      cur.first = true;
      if (cur.revealed) cur.revealY = window.scrollY;
    } else {
      relocate(false);
    }
    watch();
  }

  function loadCss(ready) {
    if (!cfg.css) return ready();
    var l = document.createElement('link');
    l.rel = 'stylesheet';
    l.href = cfg.css;
    l.onload = ready;
    l.onerror = function () {};
    document.head.appendChild(l);
  }

  function boot() {
    setTimeout(function () {
      var idle = window.requestIdleCallback || function (f) { f(); };
      idle(function () { loadCss(start); });
    }, cfg.startDelay);
  }

  if (document.readyState === 'complete') boot();
  else window.addEventListener('load', boot);
})();
